import React, { useEffect, useRef, useState } from "react";

function ApartmentBlock2({ rooms }) {
  const svgRef = useRef(null);
  const [roomCenters, setRoomCenters] = useState([]);
  const [clickedRoom, setClickedRoom] = useState(null);

  const handleBlockClick = (pathId) => {
    const room = rooms.find((room) => room.top === pathId);
    if (room) {
    
      setClickedRoom({ pathId, status: room.status });
    }
  };

  useEffect(() => {
    if (svgRef.current) {
      const paths = svgRef.current.querySelectorAll("path");
      const centers = Array.from(paths).map((path) => {
        const bbox = path.getBBox();
        const centerX = bbox.x + bbox.width / 2;
        const centerY = bbox.y + bbox.height / 2;
       
        return { centerX, centerY, pathId: path.id };
      });
      setRoomCenters(centers);
    }
  }, [rooms]);
  return (
    <div className="relative w-[100%] h-[100%]">
      <svg width="100%" height="100%" viewBox="0 0 1920 1080" ref={svgRef}>
        <path
          id="B2 - 01"
          stroke="#a2a4b4"
          strokeWidth="10"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B2 - 01")}
          fill={
            clickedRoom?.pathId === "B2 - 01"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c1c1cc"
          }
          d="
M645.058228,555.026978 
	L510.573181,555.011475 376.088135,554.995361 241.603073,554.980896 
	L210.939774,554.977600 180.275650,554.869629 149.613998,555.094849 
	L144.847549,555.129822 143.830841,553.609436 143.877823,549.168213 
	L144.092834,528.839355 143.854172,508.505707 144.069168,488.176849 
	L144.114227,483.915375 142.741180,482.918640 138.680862,482.936340 
	L104.685226,483.084686 70.688164,482.932220 36.692997,483.126740 
	L32.073833,483.153168 30.873333,481.867310 30.877850,477.285187 
	L31.000032,353.298889 30.974598,229.312454 30.975302,105.326042 
	L30.975338,99.007195 30.980808,99.003410 37.601486,99.003395 
	L305.072174,99.002777 572.542847,99.002899 840.013550,99.002441 
	L841.679993,99.002441 843.346375,98.995621 845.558777,99.240898 
	L846.144226,99.660927 846.183655,99.832039 846.135864,100.463989 
	L846.028503,101.590332 845.990906,102.255844 845.990906,102.921364 
	L845.981262,230.624115 845.973572,358.326843 845.976196,486.029602 
	L845.976196,487.356445 846.112305,488.683289 846.129211,490.247742 
	L846.073547,490.485321 845.929260,490.951508 845.467285,490.969666 
	L819.724060,491.007568 794.442749,491.027313 769.089172,490.645294 
	L768.961182,489.156860 768.905457,488.070160 768.925537,486.522186 
	L768.951111,474.379608 768.900879,462.698364 768.884766,450.689301 
	L768.930542,449.922272 768.942261,449.483002 768.891968,448.638367 
	L767.341492,447.819794 765.853577,447.048462 764.364380,447.045868 
	L726.448730,446.979218 688.532959,446.979614 650.617249,447.041992 
	L649.100525,447.044495 647.584961,447.768188 646.070190,448.388733 
	L646.071533,448.621613 646.150879,449.080566 646.092651,449.067322 
	L646.034424,449.054108 645.920044,449.019806 645.636963,449.320038 
	L645.237366,450.268646 645.018616,450.917023 645.018860,451.565369 
	L645.029846,486.025208 645.059326,520.485046 645.090576,554.969238 
	L645.094238,554.993591 645.058228,555.026978 645.058228,555.026978 
z"
        />
        <path
          id="B2 - 02"
          stroke="#a2a4b4"
          strokeWidth="10"
          transform="translate(0, -10)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B2 - 02")}
          fill={
            clickedRoom?.pathId === "B2 - 02"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#c1c1cc"
          }
          d="
M143.948593,635.975708 
	L143.948593,612.862183 143.948593,589.748657 143.948593,565.158386 
	L199.937515,565.124329 255.326416,565.077454 310.715302,565.060669 
	L366.364563,565.043823 422.013794,565.057922 477.663055,565.056763 
	L533.145691,565.055664 588.628357,565.052551 644.608032,565.052979 
	L645.104980,565.055603 645.086243,565.112793 645.053833,565.569275 
	L645.013489,600.122253 644.992493,634.218750 645.039673,668.315186 
	L645.041809,669.874207 645.657471,671.432495 646.452637,673.061707 
	L687.290039,673.104919 727.662292,673.077576 768.370483,672.785583 
	L768.753235,658.684326 768.799988,644.847778 768.893066,630.669983 
	L769.021301,629.877625 769.103149,629.426392 769.637451,628.998840 
	L795.191223,629.022461 820.292480,629.022461 846.060913,629.022461 
	L846.060913,657.824646 846.060913,685.932861 846.024414,714.505127 
	L846.015564,767.616028 846.043213,820.262939 846.058716,873.194519 
	L846.055420,873.668884 846.064270,873.858582 846.073120,874.048340 
	L846.057556,921.041687 845.972046,968.035217 846.132935,1015.027954 
	L846.149231,1019.790771 844.947388,1021.154175 840.087891,1021.152100 
	L572.458191,1021.034790 304.828491,1021.032898 37.198799,1021.164062 
	L32.111351,1021.166565 30.853872,1019.868286 30.859915,1014.808960 
	L31.007746,890.992920 30.975016,767.176575 30.976133,643.360352 
	L30.976191,637.015564 30.982430,637.013855 37.570362,637.013123 
	L72.398720,637.009277 107.227081,637.006348 142.749847,636.898438 
	L143.728882,636.592896 143.896988,636.320190 143.948593,635.975708 
z"
        />

        <path
          id="B2 - 03"
          stroke="#2a2d30"
          strokeWidth="10"
          transform="translate(-18, 0)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B2 - 03")}
          fill={
            clickedRoom?.pathId === "B2 - 03"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#52555f"
          }
          d="
M1241.309082,490.916412 
	L1241.262573,489.918457 1241.175537,488.920502 1241.175537,487.922546 
	L1241.181274,358.613251 1241.193237,229.303940 1241.256592,99.535316 
	L1243.140869,99.051628 1244.973511,99.005951 1246.806274,99.005920 
	L1454.458984,99.002777 1662.111572,99.003029 1869.764282,99.003098 
	L1871.906128,99.003098 1874.047974,99.003098 1876.595337,99.003098 
	L1876.595337,250.984528 1876.595337,402.538696 1876.595337,554.592773 
	L1875.255737,554.714417 1873.829224,554.957275 1872.402832,554.957275 
	L1729.579468,554.957703 1586.756104,554.939880 1443.466309,554.425659 
	L1443.000000,520.858459 1443.015015,487.788605 1442.961182,454.718872 
	L1442.958008,452.811798 1442.394897,450.905670 1442.021973,448.823914 
	L1441.951660,448.648743 1441.925903,448.272064 1441.704834,447.902100 
	L1441.020386,447.369202 1440.557251,447.063904 1440.093872,447.063477 
	L1400.469849,447.026978 1360.845947,446.997528 1321.222168,447.091583 
	L1320.201904,447.094025 1319.184692,448.467773 1318.185791,449.657501 
	L1318.106689,463.746948 1318.007935,477.380829 1317.448730,491.006592 
	L1291.761841,490.971100 1266.535522,490.943756 1241.309082,490.916412 
z"
        />
        <path
          id="B2 - 04"
          stroke="#2a2d30"
          strokeWidth="10"
          transform="translate(-18, -10)"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B2 - 04")}
          fill={
            clickedRoom?.pathId === "B2 - 04"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#52555f"
          }
          d="
M1241.033691,872.046570 
	L1241.079712,835.298767 1241.135498,798.550964 1241.167480,761.803162 
	L1241.181030,746.172180 1241.144653,730.541138 1241.094360,713.975830 
	L1241.057739,685.153992 1241.057739,657.266479 1241.057739,629.078918 
	L1267.298584,629.078918 1292.601318,629.078918 1318.006348,629.533325 
	L1318.136597,642.635315 1318.313232,655.285400 1318.108276,667.929199 
	L1318.040161,672.129761 1319.451904,673.373230 1323.560303,673.259155 
	L1333.039307,672.995972 1342.530640,673.188599 1352.016968,673.170837 
	L1381.971313,673.114868 1411.925659,673.047119 1442.205811,672.715088 
	L1442.687866,670.646179 1442.978638,668.846375 1442.980103,667.046265 
	L1443.007690,633.130859 1443.000854,599.215393 1443.001343,565.299988 
	L1445.163208,565.224182 1447.325195,565.082214 1449.487061,565.082031 
	L1589.632568,565.071533 1729.778076,565.072571 1869.923584,565.072571 
	L1872.051392,565.072571 1874.179199,565.072571 1876.649658,565.072571 
	L1876.649658,717.171936 1876.649658,868.713501 1876.649658,1020.661011 
	L1665.001587,1020.661011 1453.468140,1020.661011 1241.068359,1020.661011 
	L1241.068359,971.761169 1241.068359,922.850952 1241.061157,873.232910 
	L1241.053955,872.525146 1241.033691,872.046570 1241.033691,872.046570 
z"
        />

        <path
          fill="white"
          transform="translate(0, -5)"
          d="
M1317.916626,501.306335 
	C1318.021606,501.661804 1318.126709,502.017303 1318.156982,503.099304 
	C1318.060547,541.094543 1318.036743,578.363342 1318.030273,615.632080 
	C1318.030151,616.451965 1318.224976,617.271851 1318.328857,618.091736 
	C1318.328857,618.091736 1318.136719,618.185913 1317.864746,618.169800 
	C1317.331543,618.297607 1317.137207,618.504333 1316.545654,618.845825 
	C1287.698975,618.917786 1259.316406,618.917786 1230.854248,618.917786 
	C1230.854248,651.050232 1230.854248,682.347595 1230.854248,713.644897 
	C1106.263550,713.658813 981.672913,713.672729 856.581543,713.231689 
	C856.135254,697.980469 856.243469,683.184204 856.229614,668.388062 
	C856.214478,652.258362 856.086304,636.128723 855.828735,619.597534 
	C853.669006,619.095093 851.688232,618.911682 849.706909,618.905884 
	C823.463806,618.828918 797.220581,618.776917 770.859985,618.500183 
	C770.239807,617.860779 769.737000,617.439880 769.165344,616.553833 
	C769.142578,578.386597 769.188599,540.684509 769.373901,502.900085 
	C769.738892,502.520294 769.706055,502.244263 769.295532,501.945587 
	C769.176453,501.901489 768.951233,502.018860 769.081604,501.841980 
	C769.211975,501.665070 769.283386,501.231445 769.732483,501.275330 
	C795.415222,501.254913 820.648804,501.190643 845.869141,501.188446 
	C845.855774,501.250519 845.957092,501.327026 846.104370,501.531494 
	C846.566101,501.688354 846.880493,501.640808 847.194885,501.593262 
	C850.691223,501.624298 854.187500,501.682434 857.683838,501.682404 
	C985.091125,501.681030 1112.498413,501.674255 1240.641113,501.776428 
	C1241.583862,501.870972 1241.791382,501.857361 1242.445557,501.915985 
	C1245.898560,501.951385 1248.904785,501.914520 1252.150635,501.913452 
	C1252.744263,501.944641 1253.017212,501.793579 1253.661865,501.456696 
	C1275.381958,501.380371 1296.649292,501.343353 1317.916626,501.306335 
z"
        />

        <text
          textAnchor="middle"
          fontSize="30"
          stroke="black"
          strokeWidth="0.1"
          fontFamily="Arial"
        >
          <tspan x="1050" y="565">
            2.5 M WIDE CORRIDOR
          </tspan>
        </text>
        <path
          fill="#9294a3"
          stroke="#3e4247"
          strokeWidth="10"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          transform="translate(-8, 0)"
          d="
M858.023438,724.203430 
	L859.353699,724.164124 860.683960,724.090515 862.014221,724.090515 
	L983.361023,724.085205 1104.707764,724.085388 1226.054565,724.088196 
	L1227.052856,724.088196 1228.051147,724.127808 1229.600586,724.373047 
	L1230.299561,724.786011 1230.482422,724.930542 1230.700317,725.030579 
	L1230.766724,741.684143 1230.871094,758.337585 1230.890747,774.991211 
	L1230.922729,801.976501 1230.898926,828.961853 1230.898682,855.947144 
	L1230.898560,857.750916 1230.898682,859.554688 1230.898682,861.774536 
	L1106.177612,861.774536 981.878418,861.774536 856.941162,861.774536 
	L856.941162,816.438354 856.941162,771.190735 857.191772,725.387634 
	L857.696045,724.678040 857.889771,724.468445 858.023438,724.203430 
z"
        />
        <text
          x="1030"
          y="795"
          textAnchor="middle"
          alignmentBaseline="middle"
          fontSize="25"
          fill="black"
          fontFamily="Arial"
        >
          CORE
        </text>

        <path
          fill="#9294a3"
          stroke="#3e4247"
          strokeWidth="10"
          transform="translate(-8, 0)"
          d="
M1229.974121,490.835999 
	L1227.977905,490.893921 1225.981567,491.002380 1223.985352,491.002533 
	L1103.851196,491.010925 983.716980,491.010437 863.582764,491.010803 
	L861.611511,491.010803 859.640259,491.010803 857.178101,491.010803 
	L857.075378,488.839417 856.918884,487.074188 856.918701,485.308960 
	L856.906616,358.343292 856.906006,231.377609 856.909119,104.411942 
	L856.909241,98.384598 857.292297,97.982803 863.497131,97.982330 
	L983.131470,97.973099 1102.765747,97.967072 1222.400146,98.029922 
	L1225.117065,98.031349 1227.833374,98.840675 1230.682129,99.294174 
	L1230.769897,100.873619 1230.888916,102.014793 1230.888794,103.155975 
	L1230.881592,231.787415 1230.865479,360.418854 1230.628174,489.621124 
	L1230.208496,490.370514 1230.064453,490.585175 1229.974121,490.835999 
z"
        />
        <text textAnchor="middle" fontSize="25" fill="black" fontFamily="Arial">
          <tspan x="1030" dy="300">
            CORE
          </tspan>
        </text>

        <path
          fill="#9294a3"
          stroke="#3e4247"
          strokeWidth="10"
          transform="translate(-140, -56) scale(1.2, 1.1)"
          d="
M758.004761,460.001556 
	L758.051025,486.634827 758.122070,513.268066 758.137573,539.901367 
	L758.160217,578.689209 758.142944,617.476990 758.142700,656.264832 
	L758.142639,658.232117 758.142700,660.199402 758.142700,662.853821 
	L724.458923,662.853821 691.231323,662.853821 657.525635,662.590942 
	L657.047485,662.328003 657.008972,661.927368 657.006042,661.463257 
	L657.004578,594.019226 657.006104,527.039246 657.024902,459.853882 
	L657.042297,459.648468 657.079956,459.237854 657.079956,459.237854 
	L690.069824,459.196564 723.059631,459.155273 756.643311,459.337891 
	L757.450745,459.782043 757.706604,459.928619 758.004761,460.001556 
z"
        />
        <text textAnchor="middle" fontSize="20" fill="black" fontFamily="Arial">
          <tspan x="710" dy="550">
            SERVICE
          </tspan>
          <tspan x="710" dy="30">
            CORE
          </tspan>
        </text>

        <path
          fill="#9294a3"
          stroke="#3e4247"
          strokeWidth="10"
          transform="translate(-293, -57) scale(1.2, 1.1)"
          d="
M1330.026367,459.236572 
	L1363.034058,459.197388 1396.041626,459.158234 1429.636719,459.339600 
	L1430.427368,459.774353 1430.670410,459.924164 1430.953125,460.009583 
	L1430.998779,480.828613 1431.074829,501.647644 1431.084229,522.466675 
	L1431.104248,567.107178 1431.089844,611.747742 1431.089600,656.388245 
	L1431.089600,658.344788 1431.089600,660.301331 1431.089600,662.581360 
	L1396.991089,662.581360 1363.423950,662.581360 1329.041260,662.581360 
	L1329.041260,595.356567 1329.041260,528.154114 1329.279419,460.395355 
	L1329.741089,459.683716 1329.910645,459.482880 1330.026367,459.236572 
z"
        />
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 2000 1000"
          xmlns="http://www.w3.org/2000/svg"
        >
          <text
            textAnchor="middle"
            fontSize="21"
            fill="black"
            fontFamily="Arial"
          >
            <tspan x="1418" dy="510">
              SERVICE
            </tspan>
            <tspan x="1418" dy="30">
              CORE
            </tspan>
          </text>
        </svg>
        {rooms?.map((roomSec, index) => {
         
          const { unit, room } = roomSec;
          const roomCenter = roomCenters.find(
            (center) => center.pathId === roomSec.top
          );

          return (
            roomCenter && (
              <text
                key={index}
                x={roomCenter.centerX}
                y={roomCenter.centerY}
                fontSize="25"
                fill="black"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="bold"
              >
                <tspan x={roomCenter.centerX} dy="-0.8em">
                  {unit}
                </tspan>
                <tspan x={roomCenter.centerX} dy="2em">
                  {room}
                </tspan>
              </text>
            )
          );
        })}
      </svg>
    </div>
  );
}

export default ApartmentBlock2;
